import Request from "utils/requests/api";
import initializeConfig from "utils/requests/api.config";

export const BASE_URL_MANAGEMENT = async () => {
  const { management } = await initializeConfig();
  return `${management}`;
};

export interface IRequestProcess {
  orderBy: string;
  ascending: boolean;
  _size: number;
  _page: number;
  filter: string;
}

export interface IRequestPostProcess {
  description: string;
  documents: IDocuments[];
  events: number[];
  allowImageCapture: boolean;
}
export interface IDocuments {
  id: number;
  documentEventType: number[];
}
export interface IRequestUpdateProcess {
  description: string;
  documents: IDocuments[];
  events: number[];
  allowImageCapture: boolean;
}

export interface IRequestUpdateProcessId {
  processId: number;
}

export const getProcessRegister = async ({ orderBy, ascending, _size, _page, filter }: IRequestProcess) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();

  return (await Request).get(`${baseUrlManagement}processes:paginated`, {
    orderBy,
    ascending,
    _size,
    _page,
    filter,
  });
};

export const getDocuments = async ({ actives }) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).get(`${baseUrlManagement}documents?actives=${actives}`);
};

export const saveNewProcess = async (params: IRequestPostProcess) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).post(`${baseUrlManagement}processes`, params);
};

export const deleteProcess = async (id: number) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).delete(`${baseUrlManagement}processes/?processId=${id}`);
};

export const updateProcess = async (params: IRequestUpdateProcess, processId: IRequestUpdateProcessId) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).put(`${baseUrlManagement}processes/${processId}`, params);
};

export const getProcessById = async ({ id }) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).get(`${baseUrlManagement}processes/${id}`);
};

export const getAllProcess = async () => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).get(`${baseUrlManagement}processes:all`);
};
